/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 45);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Ajax request class
 */
var EpsilonAjaxRequest = /** @class */ (function () {
    /**
     * Constructor
     * @param {Object} args
     */
    function EpsilonAjaxRequest(args) {
        this.args = args;
    }
    /**
     * Init Request
     */
    EpsilonAjaxRequest.prototype.request = function () {
        var self = this;
        jQuery.ajax({
            type: 'POST',
            data: { action: 'epsilon_framework_ajax_action', args: self.args },
            dataType: 'json',
            url: EpsilonWPUrls.ajaxurl,
            success: function (data) {
                self.result = data;
                jQuery(self).trigger('epsilon-received-success');
            },
            /**
             * Throw errors
             *
             * @param jqXHR
             * @param textStatus
             * @param errorThrown
             */
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
            }
        });
    };
    return EpsilonAjaxRequest;
}());
exports.EpsilonAjaxRequest = EpsilonAjaxRequest;


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
var EpsilonColorSchemesPreviewer = /** @class */ (function () {
    /**
     * Constructor
     */
    function EpsilonColorSchemesPreviewer() {
        var self = this;
        wp.customize.preview.bind('update-inline-color-schemes-css', function (object) {
            var data = {
                action: [object.class, object.action],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: object.data,
                id: object.id
            }, Ajax;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                var sufix = object.action + object.id, style = jQuery('#epsilon-stylesheet-' + sufix);
                if (!style.length) {
                    style = jQuery('body').
                        append('<style type="text/css" id="epsilon-stylesheet-' + sufix + '" />').
                        find('#epsilon-stylesheet-' + sufix);
                }
                if (style.html() !== Ajax.result.css) {
                    style.html(Ajax.result.css);
                }
            });
        });
    }
    return EpsilonColorSchemesPreviewer;
}());
exports.EpsilonColorSchemesPreviewer = EpsilonColorSchemesPreviewer;


/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
var EpsilonPartialRefresh = /** @class */ (function () {
    /**
     * Handle the section partial refresh
     */
    function EpsilonPartialRefresh() {
        /**
         * Frontend sections
         */
        this.sections = [];
        /**
         * Register sections
         */
        this.registerSections();
        this.handleEvents();
    }
    /**
     * Register sectiosn
     */
    EpsilonPartialRefresh.prototype.registerSections = function () {
        var self = this;
        var $sections = jQuery('[data-customizer-section-id]');
        for (var i = 0; i < $sections.length; i++) {
            var id = jQuery($sections[i]).attr('data-section');
            var section = {
                id: parseInt(id),
                section: jQuery($sections[i]),
            };
            self.sections.push(section);
        }
    };
    /**
     * Handle events
     */
    EpsilonPartialRefresh.prototype.handleEvents = function () {
        var self = this;
        wp.customize.preview.bind('updated-section-repeater', _.debounce(function (object) {
            self.changeSection(object);
        }, 300));
    };
    /**
     * Change the section
     * @param object
     */
    EpsilonPartialRefresh.prototype.changeSection = function (object) {
        var self = this;
        var args = {
            action: ['Epsilon_Page_Generator', 'generate_partial_section'],
            nonce: EpsilonWPUrls.ajax_nonce,
            args: {
                control: object.control,
                postId: object.postId,
                id: object.index,
                value: object.value,
            }
        }, Ajax;
        Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
        Ajax.request();
        this.standBySection(self.sections[object.index].section);
        jQuery(Ajax).on('epsilon-received-success', function (e) {
            self.liveSection(object.index, self.sections[object.index].section, Ajax.result.section);
            jQuery(document).trigger('epsilon-selective-refresh-ready');
        });
    };
    /**
     * Stand by section
     * @param {JQuery} section
     */
    EpsilonPartialRefresh.prototype.standBySection = function (section) {
        section.animate({ opacity: .5 });
    };
    /**
     *
     * @param {JQuery} section
     */
    EpsilonPartialRefresh.prototype.liveSection = function (sectionIndex, section, result) {
        var self = this;
        section.replaceWith(result);
        self.sections = [];
        self.registerSections();
        section.animate({ opacity: 1 });
    };
    return EpsilonPartialRefresh;
}());
exports.EpsilonPartialRefresh = EpsilonPartialRefresh;


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EpsilonSectionEditorPreviewer = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EpsilonSectionEditorPreviewer() {
        jQuery(document).on('click', '.epsilon-section-editor', function (e) {
            e.preventDefault();
            var object = {
                section: jQuery(this).parents('[data-section]').attr('data-section'),
                customizerSection: jQuery(this).parents('[data-section]').attr('data-customizer-section-id')
            };
            wp.customize.preview.send('epsilon-section-edit', object);
        });
    }
    return EpsilonSectionEditorPreviewer;
}());
exports.EpsilonSectionEditorPreviewer = EpsilonSectionEditorPreviewer;


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
var EpsilonTypographyPreviewer = /** @class */ (function () {
    /**
     * Constructor
     */
    function EpsilonTypographyPreviewer() {
        var self = this;
        wp.customize.preview.bind('update-inline-typography-css', function (object) {
            var style, data = {
                action: [object.class, object.action],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: object.data,
                id: object.id
            }, Ajax;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(data);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                style = jQuery('#' + Ajax.result.stylesheet + '-inline-css');
                if (!style.length) {
                    style = jQuery('body').append('<style type="text/css" id="' + Ajax.result.stylesheet + '-inline-css" />').find('#' + Ajax.result.stylesheet + '-inline-css');
                }
                for (var i = 0; i < Ajax.result.fonts.length; i++) {
                    if (!jQuery('link[href="https://fonts.googleapis.com/css?family=' + Ajax.result.fonts[i] + '"]').length) {
                        jQuery('head').append('<link href="https://fonts.googleapis.com/css?family=' + Ajax.result.fonts[i] + '" rel="stylesheet">');
                    }
                }
                style.html(Ajax.result.css);
            });
        });
    }
    return EpsilonTypographyPreviewer;
}());
exports.EpsilonTypographyPreviewer = EpsilonTypographyPreviewer;


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var color_schemes_1 = __webpack_require__(29);
var typography_1 = __webpack_require__(32);
var section_editor_1 = __webpack_require__(31);
var partial_refresh_1 = __webpack_require__(30);
wp.customize.bind('preview-ready', function () {
    new color_schemes_1.EpsilonColorSchemesPreviewer();
    new typography_1.EpsilonTypographyPreviewer();
    new section_editor_1.EpsilonSectionEditorPreviewer();
    new partial_refresh_1.EpsilonPartialRefresh();
});


/***/ })

/******/ });


// WEBPACK FOOTER //
// epsilon-framework-previewer.js